import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../environment';

export interface IGeocodeResult {
    isCollection: boolean;
    magicKey: string;
    text: string;
}

export interface IGeocodeFindResult {
    candidates: {
        address: string;
        location: {
            x: number;
            y: number;
        };
        Score: number;
        attributes: {
            Addr_Type: string;
        };
        extent: {
            xmax: number;
            xmin: number;
            ymax: number;
            ymin: number;
        };
    }[];
    spatialReference: {
        latestWkid: number;
        wkid: number;
    };
}

@Injectable({
    providedIn: 'root'
})
export class GeocodeService {
    searchExtent: any = {
        xmin: -8963167.0999474,
        ymin: 4815933.74691319,
        xmax: -8306549.08350328,
        ymax: 5238680.50536529,
        spatialReference: { wkid: 102100 }
    };

    categories: any = ['Address', 'POI'].join(',');

    constructor(private readonly http: HttpClient) { }

    public suggest(text: string, maxSuggestions?: number): Observable<{ suggestions: IGeocodeResult[] }> {
        let url = environment.geocodeServerUrl + '/suggest?';
        url += this.buildQueryString({
            text,
            searchExtent: JSON.stringify(this.searchExtent),
            category: this.categories,
            maxSuggestions: maxSuggestions === null ? undefined : maxSuggestions,
            location: environment.geocodeStartingLocation,
            f: 'json'
        });

        return this.http.get<{ suggestions: IGeocodeResult[] }>(url).pipe(catchError(this.handleError.bind(this)));
    }

    public find(text: string, magicKey?: string): Observable<IGeocodeFindResult> {
        let url = environment.geocodeServerUrl + '/findAddressCandidates?';
        const params: any = {
            address: text,
            countryCode: 'USA',
            outSR: 102100,
            searchExtent: JSON.stringify(this.searchExtent),
            f: 'json'
        };

        if (magicKey) {
            params.magicKey = magicKey;
        }

        url += this.buildQueryString(params);

        return this.http.get<IGeocodeFindResult>(url).pipe(catchError(this.handleError.bind(this)));
    }

    private buildQueryString(params) {
        const str = [];
        for (const p in params) {
            if (params.hasOwnProperty(p)) {
                str.push(`${encodeURIComponent(p)}=${encodeURIComponent(params[p])}`);
            }
        }
        return str.join('&');
    }

    private handleError(err) {
        let errorMessage: string;
        if (err.error instanceof ErrorEvent) {
            // client-side or network
            errorMessage = `An error occured: ${err.error.message}`;
        } else {
            // backend returned an unsuccessful response code.
            errorMessage = `Backend return code ${err.status}: ${err.body.error}`;
        }

        console.error(err);
        return throwError(errorMessage);
    }
}
